import React from 'react';
import Texture from './Texture';
import Loader from '../../generic/Loader';

export const TextureListView = ({
  textures = [],
  controls = false,
  ready = true,
  exhibitionId,
}) => (
  <div className="texture-list-wrapper">
    <div className="texture-list">
      <div className="textures ui horizontal list inverted">
        {textures.map(
          texture =>
            texture._id && (
              <div key={texture._id} className="item">
                <Texture texture={texture} controls={controls} exhibitionId={exhibitionId} />
              </div>
            ),
        )}
      </div>
    </div>
    {ready || <Loader inverted={false} />}
  </div>
);

const TextureList = TextureListView;

export default TextureList;
